import DatePicker from '../../../components/Forms/DatePicker/DatePicker';
import InputField from '../../../components/Forms/Input/InputField';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';

const PurchaseCreditMonthsSection = () => {
  const { form, updateField, purchaseSettlementLoaded } = useBasePurchase();

  return (
    <>
      <DatePicker
        name="paymentCondition.creditDueDate"
        label="Fecha Plazo del Crédito"
        iconKey="calendar"
        value={form.paymentCondition?.creditDueDate || ''}
        placeholder="Fecha automática"
        helperText="Este campo se calcula automáticamente según los meses."
        disabled
        onChange={() => {}}
      />

      <InputField
        name="paymentCondition.creditMonths"
        label="Meses Plazo del Crédito"
        iconKey="calendar"
        type="number"
        min={0}
        placeholder="Meses plazo del crédito"
        value={
          form.paymentCondition?.creditMonths !== undefined &&
          form.paymentCondition?.creditMonths !== null
            ? form.paymentCondition.creditMonths
            : ''
        }
        onChange={(e) => {
          const value = e.target.value.trim();

          if (value === '') {
            updateField('paymentCondition', {
              ...form.paymentCondition,
              creditMonths: undefined,
              creditDueDate: '',
            });
            return;
          }

          const months = Number(value);
          if (form.purchaseDate && !isNaN(months)) {
            const start = new Date(form.purchaseDate);
            const dueDate = new Date(start);
            dueDate.setMonth(start.getMonth() + months);

            updateField('paymentCondition', {
              ...form.paymentCondition,
              creditMonths: months,
              creditDueDate: dueDate.toISOString().split('T')[0],
            });
          }
        }}
        disabled={purchaseSettlementLoaded}
      />
    </>
  );
};

export default PurchaseCreditMonthsSection;
